import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography'

import { AppConfig } from '../AppConfig';
import { AppTheme, AppStyles } from '../styles/AppTheme';

export class Footer extends Component {
  render() {
    return(
      <footer className={css(Styles.footer)}>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <div className={css(Styles.footerEnquiry)}>
              <p>Contact</p>
              <div className = {css(Styles.footerReference)}>
                {this.renderContact(AppConfig.Contact)}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <List component='nav'>
              <ListItem className={css(Styles.footerListitem)} component='a' href='/terms'>
                <ListItemText
                  primary={<Typography className={css(Styles.footerListlink)}>Terms</Typography>} />
              </ListItem>
              <ListItem className={css(Styles.footerListitem)} component='a' href='/privacy'>
                <ListItemText
                  primary={<Typography className={css(Styles.footerListlink)}>Privacy policy</Typography>} />
              </ListItem>
              <ListItem className={css(Styles.footerListitem)}>
                <ListItemText
                  primary={<Typography className={css(Styles.infoText)}>Version {AppConfig.Version}</Typography>} />
              </ListItem>
              <ListItem className={css(Styles.footerListitem)}>
                <ListItemText
                  primary={<Typography className={css(Styles.infoText)}>Copyright © 2018 {AppConfig.Name}</Typography>} />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </footer>
    );
  }

  renderContact(info) {
    return (
      <div>
        <a className={css(Styles.footerReference)}
          href={'mailto:' + info.email}>
          <span>{info.email}</span>
        </a>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  footer: {
    paddingBottom: 30,
    paddingLeft: 10,
    // paddingRight: 10,
    backgroundColor: AppTheme.primaryColor,
  },
  footerListitem: {
    padding: 0,
    paddingBottom: 5,
    textAlign: 'right',
    '@media (max-width: 767px)': {
      textAlign: 'center'
    }
  },
  footerListlink: {
    color: 'white',
    fontSize: 16
  },
  infoText: {
    color: 'white',
  },
  footerEnquiry: {
    color: 'white',
    textAlign: 'left',
    '@media (max-width: 767px)': {
      textAlign: 'center'
    }
  },
  footerReference: {
    color: 'white',
    textDecoration: 'none'
  }
})


// WEBPACK FOOTER //
// ./src/components/Footer.js